import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { EntityService } from '../../abstract/EntityService';

@Injectable({
  providedIn: 'root'
})
export class ItemsService extends EntityService {

  protected readonly url = 'iam-tax/using-register';

  getRegisterTypeEnums(): Observable<any> {
    return this.http.get(`iam-common/digital-signature-regis-type`);
  }
  getTvanLog(agreementId: any): Observable<any> {
    return this.http.get(`${this.url}/${agreementId}/tvan-log`);
  }
  pullTVan(id: string, item?: any): Observable<any> {
    return this.http.put(`${this.url}/${id}/pull`, item);
  }
  getUsingRegisterTypes(): Observable<any> {
    return this.http.get(`iam-common/invoice-using-regis-type`);
  }

  getDigitalSignatures(): Observable<any> {
    return this.http.get(`iam-party/digital-signatures`);
  }

  deleteDigitalSignature(id: string, param: string): Observable<any> {
    return this.http.put(`iam-party/digital-signatures/${id}/delete`, { partyOtherIndentId: param })
  }

  getAgreementNo(): Observable<any> {
    return this.http.get(`${this.url}/agreement-no`);
  }
  getAgreementInfo(): Observable<any> {
    return this.http.get(`${this.url}/agreement-info`);
  }

  getTVanLog(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/tvan-log`);
  }

  getMessage103Html(id: string): Observable<any> {
    return this.http.get(`${this.url}/${id}/message103-html`);
  }


  signByHsm(item: any): Observable<any> {
    return this.http.post(`${this.url}/${item.agreementId}/hsm-signed`, item);
  }

  getInvoiceProvider(): Observable<any> {
    return this.http.get(`iam-common/invoice-provider-default`);
  }

  getTvanProvider(): Observable<any> {
    return this.http.get(`iam-common/tvan-provider-default`);
  }


  disable(id: string): Observable<any> {
    return this.http.put(`${this.url}/${id}/disable`, {});
  }

  getAgreementAccepted(): Observable<any> {
    return this.http.get(`${this.url}/agreement-accepted`);
  }

}
